var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeater = function SvgSeater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "seater_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#seater_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M5.45 13q-.5 0-.85-.35a1.16 1.16 0 0 1-.35-.85V5.165a.484.484 0 0 1 .5-.5.484.484 0 0 1 .5.5v6.633q0 .068.067.134.066.066.133.066h3.967q.216 0 .358.142a.49.49 0 0 1 .142.358.49.49 0 0 1-.142.359.49.49 0 0 1-.358.141zm1.967-8.834q-.518 0-.876-.358a1.2 1.2 0 0 1-.358-.875q0-.518.358-.876.36-.357.876-.358.516 0 .875.358.358.36.358.876t-.358.875q-.359.358-.875.358m3.833 10.333a.49.49 0 0 1-.359-.141.49.49 0 0 1-.141-.359v-2.666H7.083q-.483 0-.825-.342a1.13 1.13 0 0 1-.341-.825v-3.75q0-.65.433-1.075a1.47 1.47 0 0 1 1.067-.425 1.465 1.465 0 0 1 1.5 1.5v3.25h1.666q.484 0 .826.341.34.342.341.826v3.166a.49.49 0 0 1-.141.359.49.49 0 0 1-.359.141"
  }))));
};
export default SvgSeater;